import { useLocation, useNavigate } from "react-router-dom";
import { STRING, STRINGS } from "../constant";
import { IMAGES } from "../assets";
import { Header, LAView, LAText, LAWarningPopup, LAButton } from "../components";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { GET_COMMUNITY_MULTIPLE_QUESTION_DETAILS } from "../api/community";
import CommunityPopup from "./quickSet/CommunityPopup";
import BackArrowIcon from "../components/BackArrowIcon";
import { ThemeContext } from "../context/ThemeProvider";
import { MixpanelContext } from "../context/MixpanelProvider";
import { GET_APP_DOMAIN_LIST } from "../../app_constant";
import { BundleContext } from "../context/BundleProvider";
import ReadinessScoreImpact from "../components/ReadinessScoreImpact";
import useFeatureList from "../hooks/useFeatureList";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { 
  faTrash, 
  faUsers, 
  faRedo, 
  faChevronRight,
  faCheckCircle,
  faTimesCircle,
  faQuestionCircle,
  faClock,
  faLayerGroup,
  faBook
} from '@fortawesome/free-solid-svg-icons';
import { getPracticeTestIconBg } from "../utils/themeUtils";

function TestReview() {
  const location = useLocation();
  const { historyData, canGoBackKey, lastReadinessScore } = location.state || {};
  const state = historyData;
  const featureList = useFeatureList();

  const navigate = useNavigate();

  const testItem = state;
  const canGoBack = canGoBackKey;
  const { theme, currentTheme } = useContext(ThemeContext);
  const { deleteTestHistory, profile, isVisibleCommunity } = useContext(AuthContext);
  const { trackPracticeReview } = useContext(MixpanelContext);
  const { selectedCertificate } = useContext(BundleContext);
  const [isLoadingCommunity, setLoadingCommunity] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isDeleteWarning, setDeleteWarning] = useState(false);
  const [isTestExitPopup, setTestExitPopup] = useState(false);
  const [communityDetails, setCommunityDetails] = useState(null);
  const [communityPercentage, setCommunityPercentage] = useState(0);
  const [isCommunityPopup, setCommunityPopup] = useState(false);
  const [domainList, setDomainList] = useState([]);

  const lastReadinessScoreInt = lastReadinessScore !== undefined ? Math.round(lastReadinessScore) : null;
  const profileReadinessScoreInt = profile?.readiness_scores?.readiness_score !== undefined ? 
    Math.round(profile.readiness_scores.readiness_score) : null;

  // Card animations
  const cardVariants = {
    hover: { 
      scale: 1.02,
      boxShadow: "0px 8px 15px rgba(0,0,0,0.1)",
      transition: { type: "spring", stiffness: 400, damping: 10 }
    }
  };

  // Helper function to get icon background color
  const getIconBg = () => {
    return getPracticeTestIconBg(theme, currentTheme);
  }

  // Helper function to get card background
  const getCardBackground = (iconBg) => {
    const baseColor = currentTheme === 'light' ? theme?.homeCard?.start_light : theme?.homeCard?.start_dark;
    const darkerShade = currentTheme === 'light' ? theme?.homeCard?.end_light : theme?.homeCard?.end_dark;
    return {
      background: `linear-gradient(to right, ${baseColor}, ${darkerShade})`,
      // borderLeft: `4px solid ${iconBg || getPracticeTestIconBg(theme, currentTheme)}`
    };
  };

  // Helper function for text color
  const getTextColor = () => {
    return currentTheme === 'light' 
      ? theme?.text?.light
      : theme?.text?.dark;
  };

  useEffect(() => {
    getScoreAsPerDomain();
    if (testItem?.test_questions_meta_data && isVisibleCommunity) {
      const array = testItem?.test_questions_meta_data?.map(
        (e) => `${e.question_id}`
      );
      getCommunityDetails(array);
    }
  }, []);

  async function getCommunityDetails(ids) {
    setLoadingCommunity(true);
    const result = await GET_COMMUNITY_MULTIPLE_QUESTION_DETAILS(ids);
    setLoadingCommunity(false);

    if (result?.data?.length > 0) {
      const total_time_answered = result?.data
        .map((item) => item.times_answered)
        .reduce((prev, next) => prev + next);
      const total_time_correct = result?.data
        .map((item) => item.times_answered_correct)
        .reduce((prev, next) => prev + next);

      setCommunityDetails(result.data);

      const percentage = (total_time_correct / total_time_answered) * 100;
      setCommunityPercentage(percentage);
    } else {
      setCommunityDetails([]);
      setCommunityPercentage(0);
    }
  }

  function getProgress() {
    const rawValue = parseFloat(testItem?.score);
  
    const safeValue = isNaN(rawValue) ? 0 : rawValue;
    const progress = parseInt((safeValue * 100) / 200);
  
    return { fill: safeValue, value: isNaN(progress) ? 0 : progress };
  }
  

  function getAvarageTime() {
    const avg_time = Math.floor(testItem?.time_taken / testItem?.total);
    return avg_time + "s";
  }

  const backAction = () => {
    onBack();
    return false;
  };

  function onBack() {
    if (canGoBack) {
      navigate(-1);
    } else {
      setTestExitPopup(true);
    }
  }

  function onAllQuestionReview() {
    if (testItem?.test_questions_meta_data?.length > 0) {
      trackPracticeReview("All");
      navigate("/questionReview", {
        state: {
          state: testItem?.test_questions_meta_data,
          title: "All",
          item: testItem,
          lastReadinessScore: lastReadinessScore,
        },
      });
    }
  }

  function onUnanswerQuestionReview() {
    const questions = testItem?.test_questions_meta_data?.filter(
      (item) => item.response == STRING?.unanswered_tag
    );
    if (questions.length > 0) {
      trackPracticeReview("Unanswered");
      navigate("/questionReview", {
        state: {
          state: questions,
          title: "Unanswered",
          item: testItem,
          lastReadinessScore: lastReadinessScore,
        },
      });
    }
  }

  function onCorrectQuestionReview() {
    const questions = testItem?.test_questions_meta_data?.filter(
      (item) => item.response == STRING.correct_tag
    );
    if (questions.length > 0) {
      trackPracticeReview("Correct");
      navigate("/questionReview", {
        state: {
          state: questions,
          title: "Correct",
          item: testItem,
          lastReadinessScore: lastReadinessScore,
        },
      });
    }
  }

  function onIncorrectQuestionReview() {
    const questions = testItem?.test_questions_meta_data?.filter(
      (item) => item.response == STRING.incorrect_tag
    );
    if (questions.length > 0) {
      trackPracticeReview("Incorrect");
      navigate("/questionReview", {
        state: {
          state: questions,
          title: "Incorrect",
          item: testItem,
          lastReadinessScore: lastReadinessScore,
        },
      });
    }
  }

  async function onDelete() {
    deleteTestHistory(testItem);
    navigate("/history", { state: { isShowReview: false } });
  }

  function onRetakeTest() {
    const question_date = testItem?.test_questions_meta_data ?? [];
    const item = {
      test_name: testItem.test_name,
      test_questions_meta_data: question_date,
      num_questions: question_date.length,
      is_retake_test: true,
      is_show_answer: false,
    };
    navigate("/test", { state: item, isShowAnswer: false });
  }

  function getCommunityTestResult() {
    if (communityDetails && isVisibleCommunity) {
      if (isNaN(communityPercentage) || !isFinite(communityPercentage)) {
        return {
          color: theme.color.red.main,
          percentage: 0,
          message: STRING.community_test_popup_desc_less_50,
        };
      } else if (communityPercentage < 50) {
        return {
          color: theme.color.red.main,
          percentage: 0,
          message: STRING.community_test_popup_desc_less_50,
        };
      } else if (communityPercentage < 80) {
        return {
          color: theme.color.yellow.main,
          percentage: 0,
          message: STRING.community_test_popup_desc_less_80,
        };
      } else {
        return {
          color: theme.color.green.main,
          percentage: 0,
          message: STRING.community_test_popup_desc_less_100,
        };
      }
    }

    return {
      color: theme.color.red.main,
      percentage: 0,
      message: STRING.community_test_popup_desc_less_50,
    };
  }

  function onPressCommunity() {
    setCommunityPopup(true);
  }

  const questionReviewHandler = (e) => {
    switch (e?.name) {
      case "All":
        onAllQuestionReview();
        break;
      case "Unanswered":
        onUnanswerQuestionReview();
        break;
      case "Correct":
        onCorrectQuestionReview();
        break;
      case "Incorrect":
        onIncorrectQuestionReview();
        break;
      default:
        onAllQuestionReview();
        break;
    }
  };

  function getScoreAsPerDomain() {
    const APP_DOMAIN_LIST = GET_APP_DOMAIN_LIST(selectedCertificate);
    const domainScoreList = [];

    APP_DOMAIN_LIST.forEach((domain) => {
      const totalQuestion = (testItem?.test_questions_meta_data ?? []).filter(
        (e) => e.topic_id == domain.id
      );
      const correctQuestion = (testItem?.test_questions_meta_data ?? []).filter(
        (e) => e.topic_id == domain.id && e.response == "CORRECT"
      );
      const percentage =
        ((100 * correctQuestion?.length) / totalQuestion?.length).toFixed(2);
      if (totalQuestion?.length > 0) {
        domainScoreList.push({
          id: domain.id,
          title: domain.domain_name,
          value: `${percentage}%`,
          total: totalQuestion?.length,
          percentage: percentage,
          correct: correctQuestion?.length,
        });
      }
    });

    setDomainList(domainScoreList);
  }

  function onPressDomain(domain) {
    const questions = (testItem?.test_questions_meta_data ?? []).filter(
      (e) => e.topic_id == domain.id
    );
    if (questions.length > 0) {
      trackPracticeReview("Domain");
      navigate("/questionReview", {
        state: {
          state: questions,
          title: domain.title,
          item: testItem,
          questions: questions,
          lastReadinessScore: lastReadinessScore,
        },
      });
    }
  }

  // Get icon for review categories
  const getCategoryIcon = (name) => {
    switch(name) {
      case "All": 
        return faBook;
      case "Unanswered": 
        return faQuestionCircle;
      case "Correct": 
        return faCheckCircle;
      case "Incorrect": 
        return faTimesCircle;
      default: 
        return faBook;
    }
  };

  const progress = getProgress();
  const time = getAvarageTime();
  const testName = testItem?.test_name?.trim() ? testItem?.test_name : "-";
  const testDate = testItem?.date?.trim() ? testItem?.date : "-";
  const communitySettings = getCommunityTestResult();

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <button
            className="rounded-lg border-2 p-2 mr-4 flex items-center justify-center"
            style={{ borderColor: currentTheme === "light" ? theme?.border_color?.light : theme?.border_color?.dark }}
            onClick={() => navigate("/history")}
          >
            <BackArrowIcon
              color={currentTheme === "light" ? theme?.text?.light : theme?.text?.dark}
            />
          </button>
          <div>
            <h1 
              className="text-2xl font-semibold"
              style={{ color: getTextColor() }}
            >
              {testName}
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">{testDate}</p>
          </div>
        </div>
        
        {featureList?.history.delete_test && (
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => setDeleteWarning(true)}
            className="w-10 h-10 rounded-full flex items-center justify-center"
            style={{ backgroundColor: theme.COLOR_RED }}
          >
            <FontAwesomeIcon icon={faTrash} className="text-white" />
          </motion.button>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Left Column - Score and Controls */}
        <div className="space-y-6">
          {/* Score Card */}
          <motion.div
            className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
            whileHover="hover"
            variants={cardVariants}
          >
            <div style={getCardBackground(getIconBg())}>
              <div className="p-6">
                <div className="flex flex-col items-center">
                  {/* Score Circle */}
                  <div className="w-48 h-48 my-6">
                    <CircularProgressbar
                      value={progress.value}
                      text={`${progress.value}%`}
                      circleRatio={0.75}
                      background
                      backgroundPadding={6}
                      styles={buildStyles({
                        pathColor: getIconBg(),
                        textColor: getTextColor(),
                        textSize: "1.1rem",
                        backgroundColor: currentTheme === 'light' ? theme?.background?.light : theme?.background?.dark,
                        trailColor: currentTheme === 'light' ? theme?.homeCard?.start_end : theme?.homeCard?.end_dark,
                        rotation: 1 / 2 + 1 / 8,
                      })}
                    />
                  </div>
                  
                  {/* Average Time */}
                  <div className="flex items-center">
                    <FontAwesomeIcon 
                      icon={faClock} 
                      className="mr-2"
                      style={{ color: getIconBg() }}
                    />
                    <span style={{ color: getTextColor() }}>
                      {STRING.average_time_per_question + time}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Readiness Score Impact */}
          {lastReadinessScore !== undefined && (
            <motion.div
              className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
              whileHover="hover"
              variants={cardVariants}
            >
              <div style={getCardBackground(getIconBg())}>
                <div className="p-6">
                  <ReadinessScoreImpact
                    lastReadinessScoreInt={lastReadinessScoreInt}
                    profileReadinessScoreInt={profileReadinessScoreInt}
                  />
                </div>
              </div>
            </motion.div>
          )}

          {/* Retake Test Button */}
          {featureList?.history.retake_test && (
            <div className="flex justify-center">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={onRetakeTest}
                className="flex items-center px-6 py-3 rounded-lg font-medium text-white"
                style={{ backgroundColor: getIconBg() }}
              >
                <FontAwesomeIcon icon={faRedo} className="mr-2" />
                Retake Test
              </motion.button>
            </div>
          )}
        </div>

        {/* Right Column - Review Options */}
        <div className="space-y-6">
          {featureList?.history.review_questions && (
            <>
              {/* Review Questions Card */}
              <motion.div
                className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
                whileHover="hover"
                variants={cardVariants}
              >
                <div style={getCardBackground(getIconBg())}>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h2 
                        className="text-lg font-semibold"
                        style={{ color: getTextColor() }}
                      >
                        {STRINGS?.review_questions}
                      </h2>
                      
                      {communityDetails && isVisibleCommunity && featureList?.global.community_score && (
                        <button
                          onClick={onPressCommunity}
                          className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                        >
                          <FontAwesomeIcon 
                            icon={faUsers} 
                            style={{ color: communitySettings?.color }}
                            className="text-xl" 
                          />
                        </button>
                      )}
                    </div>
                    
                    <div className="space-y-3">
                      {[
                        { name: "All", total: testItem?.total },
                        { name: "Unanswered", total: testItem?.unanswered },
                        { name: "Correct", total: testItem?.correct },
                        { name: "Incorrect", total: testItem?.incorrect },
                      ].map((item, index) => (
                        <ReviewItem
                          key={index}
                          icon={getCategoryIcon(item.name)}
                          title={item.name}
                          count={item.total}
                          onClick={() => questionReviewHandler(item)}
                          theme={theme}
                          textColor={getTextColor()}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Domain Scores Card */}
              <motion.div
                className="bg-white dark:bg-gray-800 rounded-xl overflow-hidden shadow-sm"
                whileHover="hover"
                variants={cardVariants}
              >
                <div style={getCardBackground(getIconBg())}>
                  <div className="p-6">
                    <h2 
                      className="text-lg font-semibold mb-4"
                      style={{ color: getTextColor() }}
                    >
                      {STRING.review_domain_wise_scores}
                    </h2>
                    
                    <div className="space-y-3">
                      {domainList.map((domain, index) => (
                        <DomainScoreItem
                          key={domain.id + index}
                          title={domain.title}
                          percentage={domain.percentage}
                          correct={domain.correct}
                          total={domain.total}
                          onClick={() => onPressDomain(domain)}
                          iconBg={getIconBg()}
                          textColor={getTextColor()}
                          theme={theme}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            </>
          )}
        </div>
      </div>

      {/* Delete Warning Dialog */}
      <AnimatePresence>
        {isDeleteWarning && (
          <LAWarningPopup
            title={STRING.are_you_sure}
            desc={STRING.test_delete_warning}
            cancelText={STRING.no}
            options={[STRING.no, STRING.delete]}
            onCancle={() => {
              setDeleteWarning(false);
            }}
            onPress={async (e, index) => {
              setDeleteWarning(false);
              if (index == 1) {
                onDelete();
              }
            }}
          />
        )}
      </AnimatePresence>

      {/* Community Popup */}
      <AnimatePresence>
        {isCommunityPopup && (
          <CommunityPopup
            communitySettings={communitySettings}
            onCancle={() => {
              setCommunityPopup(false);
            }}
          />
        )}
      </AnimatePresence>
    </div>
  );
}

// Review Item Component
const ReviewItem = ({ icon, title, count, onClick, theme, textColor }) => {
  return (
    <motion.div
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className="flex items-center justify-between p-4 rounded-lg cursor-pointer bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
    >
      <div className="flex items-center">
        <div 
          className="w-10 h-10 rounded-full flex items-center justify-center mr-3"
          style={{ backgroundColor: theme.color.gray.main }}
        >
          <FontAwesomeIcon 
            icon={icon} 
            className="text-white" 
          />
        </div>
        <div>
          <p style={{ color: textColor }}>{title}</p>
        </div>
      </div>
      <div className="flex items-center">
        <span 
          className="px-3 py-1 rounded-full text-sm font-medium mr-2"
          style={{ 
            backgroundColor: 'rgba(0,0,0,0.05)',
            color: textColor 
          }}
        >
          {count}
        </span>
        <FontAwesomeIcon 
          icon={faChevronRight} 
          style={{ color: textColor }}
        />
      </div>
    </motion.div>
  );
};

// Domain Score Item Component
const DomainScoreItem = ({ title, percentage, correct, total, onClick, iconBg, textColor, theme }) => {
  // Get color based on percentage
  const getPercentageColor = (percent) => {
    if (percent < 40) return theme.color.red.main;
    if (percent < 70) return theme.color.yellow.main;
    return theme.color.green.main;
  };

  const percentageColor = getPercentageColor(percentage);

  return (
    <motion.div
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
      className="flex items-center justify-between p-4 rounded-lg cursor-pointer bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors"
    >
      <div className="flex items-center">
        <div 
          className="w-10 h-10 rounded-full flex items-center justify-center mr-3"
          style={{ backgroundColor: theme.color.gray.main }}
        >
          <FontAwesomeIcon 
            icon={faLayerGroup} 
            className="text-white" 
          />
        </div>
        <div>
          <p style={{ color: textColor }}>{title}</p>
          <div className="flex items-center mt-1">
            <div className="w-24 h-2 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden mr-2">
              <div 
                className="h-full rounded-full"
                style={{ 
                  width: `${percentage}%`,
                  backgroundColor: percentageColor
                }}
              ></div>
            </div>
            <span 
              className="text-sm font-medium"
              style={{ color: percentageColor }}
            >
              {percentage}%
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center">
        <span 
          className="px-3 py-1 rounded-full text-sm font-medium mr-2"
          style={{ 
            backgroundColor: 'rgba(0,0,0,0.05)',
            color: textColor 
          }}
        >
          {correct}/{total}
        </span>
        <FontAwesomeIcon 
          icon={faChevronRight} 
          style={{ color: textColor }}
        />
      </div>
    </motion.div>
  );
};

export default TestReview;